if (!customElements.get('sticky-product-form')) {
  customElements.define(
    'sticky-product-form',
    class StickyProductForm extends HTMLElement {
      constructor() {
        super();
        this.productStickyForm = document.querySelector('.product--sticky-form');
        this.lastScrollY = 0; // Track the last scroll position
        this.scrollingStarted = false; // Track if scrolling has started
        this.onScrollHandler = this.onScroll.bind(this);
      }

      connectedCallback() {
        window.addEventListener('scroll', this.onScrollHandler, false);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      onScroll() {
        const scrollY = window.scrollY || document.documentElement.scrollTop;

        if (scrollY > 0 && !this.scrollingStarted) {
          // User started scrolling, show the sticky form
          this.scrollingStarted = true;
          this.show();
        }

        if (scrollY === 0 && this.scrollingStarted) {
          // User reached the top of the page, hide the sticky form
          this.scrollingStarted = false;
          this.hide();
        }

        this.lastScrollY = scrollY;
      }

      hide() {
        if (this.productStickyForm) {
          this.productStickyForm.classList.remove('product--sticky-form__active');
          this.productStickyForm.classList.add('product--sticky-form__inactive');
        }
      }

      show() {
        if (this.productStickyForm) {
          this.productStickyForm.classList.add('product--sticky-form__active');
          this.productStickyForm.classList.remove('product--sticky-form__inactive');
        }
      }
    }
  );
}
